'use client';

import { HStack } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import CategoryLink from './Link';
import { useQueryState } from 'nuqs';
import { useTranslations } from 'next-intl';

interface IProps {
  data: { slug: string; title: string }[] | undefined;
  active?: { slug: string; title: string };
}



function StaticBar() {
  const [active, setActive] = useQueryState("active");
  const t = useTranslations();
  const catalogRef = useRef<any>(null);

  const data = [
    { title: t('gallery'), slug: "gallery" },
    { title: t('menu'), slug: "menu" },
    { title: t('reviews'), slug: "reviews" },
    { title: t('about'), slug: "about" },
  ]

  useEffect(() => {
    if (active) return;

    setActive("gallery");
  }, [active]);

  const handleClick = (slug: string) => {
    setActive(slug);
  }

  return (
    <>
      <HStack
        gap={{ base: 1, lg: 4 }}
        maxWidth="100%"
        ref={catalogRef}
        pt={{ base: 4, md: 8 }}
        flexWrap={{ base: 'nowrap', md: 'wrap' }}
        overflowX={{ base: 'auto', md: 'visible' }}
        scrollbar={'hidden'}
        align="stretch"
      >
        {data?.map((item, idx) => (
          <CategoryLink
            tab={item}
            active={active === item.slug}
            key={`${item.slug}-${idx}`}
            onClick={() => handleClick(item.slug)}
          />
        ))}
      </HStack>
    </>
  );
}

export default StaticBar;
